import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "DesignAi"
});
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.45117 3.8C8.45117 3.35817 8.80934 3 9.25117 3H14.1023C14.5441 3 14.9023 3.35817 14.9023 3.8V5.42555C14.9023 5.86737 14.5441 6.22555 14.1023 6.22555H9.25117C8.80934 6.22555 8.45117 5.86737 8.45117 5.42555V3.8Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.83838 5H3.6C2.71634 5 2 5.71634 2 6.6V27.5916C2 28.4752 2.71634 29.1916 3.6 29.1916H12.9706C13.6332 29.1916 14.2273 28.7831 14.4645 28.1644L18.3403 18.055C18.5713 17.4525 19.1499 17.0547 19.7952 17.0547V17.0547C20.6557 17.0547 21.3533 16.3571 21.3533 15.4966V6.6C21.3533 5.71634 20.6369 5 19.7533 5H16.515V6.63513C16.515 7.07695 16.1568 7.43513 15.715 7.43513H7.63838C7.19655 7.43513 6.83838 7.07695 6.83838 6.63513V5ZM5.62578 11.1631C5.40487 11.1631 5.22578 11.3422 5.22578 11.5631V12.7791C5.22578 13 5.40487 13.1791 5.62578 13.1791H17.728C17.9489 13.1791 18.128 13 18.128 12.7791V11.5631C18.128 11.3422 17.9489 11.1631 17.728 11.1631H5.62578ZM5.22578 15.9981C5.22578 15.7772 5.40487 15.5981 5.62578 15.5981H11.4754C11.6963 15.5981 11.8754 15.7772 11.8754 15.9981V17.2141C11.8754 17.435 11.6963 17.6141 11.4754 17.6141H5.62578C5.40487 17.6141 5.22578 17.435 5.22578 17.2141V15.9981Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M27.89 18.7607H29.8841V29.3248H27.89V18.7607Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  d: "M23.474 26.524H19.0596L18.055 29.3248H16L19.9577 18.7607H22.6368L26.5641 29.3248H24.4482L23.474 26.524ZM22.8803 24.8495L21.3734 20.5417H21.1907L19.6533 24.8495H22.8803Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var DesignAI_ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { DesignAI_ as default };
